/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Verifying extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Verifying;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/verifying.js